import { render } from "./PrintedSmallBox.vue?vue&type=template&id=b1098c5e&scoped=true"
import script from "./PrintedSmallBox.vue?vue&type=script&lang=js"
export * from "./PrintedSmallBox.vue?vue&type=script&lang=js"

import "./PrintedSmallBox.vue?vue&type=style&index=0&id=b1098c5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b1098c5e"

export default script